"use client"

import { Box, CircularProgress, LinearProgress, Paper, Skeleton, Stack, Typography } from "@mui/material";

export default function Loading({text}) {
    return (
        <main className="grid place-items-center">
            <Paper>
                <Box p={5}>
                    <Stack alignItems={"center"} gap={2}>
                        <CircularProgress />
                        <Typography fontSize={"small"}>{text}</Typography>
                    </Stack>
                </Box>
            </Paper>
        </main>
    )
}